import styled from 'styled-components';

export const TitleText = styled.div`
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 8px;
    color: #444;
`;

export const ParagraphText = styled.div`
    font-size: 16px;
    margin-bottom: 20px;
    color: #666;
`;
